import styled from 'styled-components'

const Component = styled.div`
  text-align: center;
`

const Image = styled.img`
  margin-bottom: 25px;
  width: 100%;

  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}rem) {
    margin: 50px 0 0;
  }
`

const ImageComponent = () => (
  <Component>
    <Image
      src="/static/images/how-it-works/hero/hero@3x.png"
      alt="Citifyd App"
    />
  </Component>
)

export default ImageComponent
